export var InpageWidgetVendors;
(function (InpageWidgetVendors) {
    InpageWidgetVendors["DPA"] = "DPA";
    InpageWidgetVendors["DATAWRAPPER"] = "Datawrapper";
    InpageWidgetVendors["FINANZEN"] = "Finanzen.de";
    InpageWidgetVendors["TENNISNET"] = "Tennisnet";
    InpageWidgetVendors["MOTORSPORT_TOTAL"] = "Motorsport Total";
    InpageWidgetVendors["TICKAROO"] = "Tickaroo";
    InpageWidgetVendors["DAA"] = "DAA";
    InpageWidgetVendors["AROUNDHOME"] = "Aroundhome";
    InpageWidgetVendors["COMADS"] = "CommunicationAds";
    InpageWidgetVendors["SMAVA"] = "Smava";
    InpageWidgetVendors["BAUFI24"] = "Baufi24";
    InpageWidgetVendors["CALCULATORTOOLS"] = "CalculatorTools";
    InpageWidgetVendors["CIVEY"] = "Civey";
    InpageWidgetVendors["SALARYCALCULATOR"] = "SalaryCalculator";
    InpageWidgetVendors["OFFERISTA"] = "Offerista";
    InpageWidgetVendors["OPINARY"] = "Opinary";
    InpageWidgetVendors["SPEEDTEST"] = "Speedtest";
    InpageWidgetVendors["TRACDELIGHT"] = "Tracdelight";
    InpageWidgetVendors["FITFORFUNCALCULATORS"] = "FitForFunCalculators";
    InpageWidgetVendors["TARIFCHECK"] = "Tarifcheck";
    InpageWidgetVendors["GREENVIDEO"] = "GreenVideo";
    InpageWidgetVendors["GOOGLEMAPS"] = "GoogleMaps";
})(InpageWidgetVendors || (InpageWidgetVendors = {}));
export const vendorEnumToKeyMap = {
    [InpageWidgetVendors.DPA]: 'dpa',
    [InpageWidgetVendors.DATAWRAPPER]: 'datawrapper',
    [InpageWidgetVendors.FINANZEN]: 'finanzen',
    [InpageWidgetVendors.TENNISNET]: 'tennisnet',
    [InpageWidgetVendors.MOTORSPORT_TOTAL]: 'motorsportTotal',
    [InpageWidgetVendors.TICKAROO]: 'tickaroo',
    [InpageWidgetVendors.DAA]: 'daa',
    [InpageWidgetVendors.AROUNDHOME]: 'aroundhome',
    [InpageWidgetVendors.COMADS]: 'comads',
    [InpageWidgetVendors.SMAVA]: 'smava',
    [InpageWidgetVendors.BAUFI24]: 'baufi24',
    [InpageWidgetVendors.CALCULATORTOOLS]: 'calculatortools',
    [InpageWidgetVendors.CIVEY]: 'civey',
    [InpageWidgetVendors.SALARYCALCULATOR]: 'salaryCalculator',
    [InpageWidgetVendors.OFFERISTA]: 'offerista',
    [InpageWidgetVendors.OPINARY]: 'opinary',
    [InpageWidgetVendors.SPEEDTEST]: 'speedtest',
    [InpageWidgetVendors.TRACDELIGHT]: 'tracdelight',
    [InpageWidgetVendors.FITFORFUNCALCULATORS]: 'fitforfuncalculators',
    [InpageWidgetVendors.TARIFCHECK]: 'tarifcheck',
    [InpageWidgetVendors.GREENVIDEO]: 'greenVideo',
    [InpageWidgetVendors.GOOGLEMAPS]: 'googlemaps',
};
const definition = {
    datawrapper: {
        vendor: InpageWidgetVendors.DATAWRAPPER,
        ruleset: [],
        needsConsent: false,
        adLabel: false,
        allowedBrands: ['BUNTE', 'CHIP', 'FOCUS'],
    },
    dpa: {
        vendor: InpageWidgetVendors.DPA,
        ruleset: [],
        needsConsent: false,
        adLabel: false,
        allowedBrands: ['FOCUS'],
    },
    finanzen: {
        vendor: InpageWidgetVendors.FINANZEN,
        ruleset: [/.*<div\s+id="fde-slot-am[^"]*".*?"siteKey"\s*:\s*"focusde".*$/s],
        needsConsent: true,
        vendorID: '5f5fe70c5e81e7736a7d9565',
        adLabel: true,
        allowedBrands: ['FOCUS', 'BUNTE', 'CHIP'],
    },
    tennisnet: {
        vendor: InpageWidgetVendors.TENNISNET,
        inputMode: 'url',
        urlInput: { allowedHosts: ['tennisnet.com', 'www.tennisnet.com'] },
        ruleset: [],
        needsConsent: true,
        vendorID: '6862aa0f93e27d17979950da',
        adLabel: false,
        allowedBrands: ['FOCUS'],
    },
    motorsportTotal: {
        vendor: InpageWidgetVendors.MOTORSPORT_TOTAL,
        ruleset: [],
        needsConsent: false,
        adLabel: false,
        allowedBrands: ['FOCUS'],
    },
    tickaroo: {
        vendor: InpageWidgetVendors.TICKAROO,
        vendorID: '5eb975c32a005a254474e8ff',
        ruleset: [],
        needsConsent: false,
        adLabel: false,
        allowedBrands: ['FOCUS', 'BUNTE', 'CHIP'],
    },
    daa: {
        vendor: InpageWidgetVendors.DAA,
        ruleset: [],
        needsConsent: false,
        adLabel: true,
        allowedBrands: ['FOCUS', 'BUNTE', 'CHIP'],
    },
    aroundhome: {
        vendor: InpageWidgetVendors.AROUNDHOME,
        ruleset: [],
        needsConsent: true,
        vendorID: '691e2f6d5cbcc398583e6c7b',
        adLabel: true,
        allowedBrands: ['FOCUS', 'BUNTE', 'CHIP'],
    },
    comads: {
        vendor: InpageWidgetVendors.COMADS,
        ruleset: [],
        needsConsent: false,
        adLabel: true,
        allowedBrands: ['FOCUS', 'BUNTE', 'CHIP'],
    },
    smava: {
        vendor: InpageWidgetVendors.SMAVA,
        ruleset: [],
        needsConsent: false,
        adLabel: true,
        allowedBrands: ['FOCUS', 'BUNTE', 'CHIP'],
    },
    baufi24: {
        vendor: InpageWidgetVendors.BAUFI24,
        ruleset: [],
        needsConsent: false,
        adLabel: true,
        allowedBrands: ['FOCUS', 'BUNTE', 'CHIP'],
    },
    calculatortools: {
        vendor: InpageWidgetVendors.CALCULATORTOOLS,
        ruleset: [],
        needsConsent: false,
        adLabel: false,
        allowedBrands: ['FOCUS'],
    },
    civey: {
        vendor: InpageWidgetVendors.CIVEY,
        ruleset: [],
        needsConsent: true,
        adLabel: false,
        allowedBrands: ['FOCUS', 'BUNTE', 'CHIP'],
    },
    salaryCalculator: {
        vendor: InpageWidgetVendors.SALARYCALCULATOR,
        ruleset: [],
        needsConsent: false,
        adLabel: false,
        allowedBrands: ['FOCUS'],
    },
    offerista: {
        vendor: InpageWidgetVendors.OFFERISTA,
        ruleset: [],
        needsConsent: false,
        adLabel: true,
        allowedBrands: ['CHIP'],
    },
    opinary: {
        vendor: InpageWidgetVendors.OPINARY,
        ruleset: [],
        needsConsent: true,
        vendorID: '5ef5c3a5b8e05c69980eaa5a',
        adLabel: false,
        allowedBrands: ['FOCUS', 'CHIP'],
    },
    speedtest: {
        vendor: InpageWidgetVendors.SPEEDTEST,
        ruleset: [],
        needsConsent: false,
        adLabel: false,
        allowedBrands: ['CHIP'],
    },
    tracdelight: {
        vendor: InpageWidgetVendors.TRACDELIGHT,
        ruleset: [],
        needsConsent: false,
        adLabel: true,
        allowedBrands: ['FOCUS', 'BUNTE', 'CHIP'],
    },
    fitforfuncalculators: {
        vendor: InpageWidgetVendors.FITFORFUNCALCULATORS,
        ruleset: [],
        needsConsent: false,
        adLabel: false,
        allowedBrands: ['FITFORFUN', 'CHIP'],
    },
    tarifcheck: {
        vendor: InpageWidgetVendors.TARIFCHECK,
        ruleset: [],
        needsConsent: false,
        adLabel: true,
        allowedBrands: ['FOCUS', 'BUNTE', 'CHIP'],
    },
    greenVideo: {
        vendor: InpageWidgetVendors.GREENVIDEO,
        ruleset: [],
        needsConsent: false,
        adLabel: false,
        allowedBrands: ['CHIP'],
    },
    googlemaps: {
        vendor: InpageWidgetVendors.GOOGLEMAPS,
        ruleset: [],
        needsConsent: true,
        vendorID: '63657be8bcb5be04a169758e',
        adLabel: false,
        allowedBrands: ['FOCUS'],
    },
};
export const inpageWidgetVendorConfigByKey = (vendor) => definition[vendor];
export const inpageWidgetVendorConfig = (vendorInput) => Object.values(definition).find((config) => config.vendor === vendorInput);
export const inpageWidgetVendorConfigFromType = (vendorType) => {
    const key = vendorEnumToKeyMap[vendorType];
    if (!key) {
        throw new Error(`Unknown vendor type: ${vendorType}`);
    }
    return inpageWidgetVendorConfigByKey(key);
};
export const isUrlInputInpageVendor = (vendorType) => (inpageWidgetVendorConfig(vendorType)?.inputMode ?? 'html') === 'url';
export const listUrlInputInpageVendors = () => Object.values(definition)
    .filter((config) => (config.inputMode ?? 'html') === 'url')
    .map((config) => config.vendor);
export const getUrlInputInpageVendorHosts = (vendorType) => inpageWidgetVendorConfig(vendorType)?.urlInput?.allowedHosts;
/** Editor preview iframe HTML for URL-input vendors (not persisted). */
export const buildUrlInputInpagePreviewIframe = (src) => `<iframe src="${src}" style="border:0px #ffffff none;" scrolling="auto" frameborder="1" marginheight="0px" marginwidth="0px" height="1000px" width="100%" allowfullscreen></iframe>`;
//# sourceMappingURL=inpage-widget.config.js.map